import React from "react";

const SpinnerLoadSrx = () => {
  return <div className="spinner_container"></div>;
};

export default SpinnerLoadSrx;
